/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAvailabilityContainerData } from './availability-container.data';
import { IAvailabilityContainerProps } from './availability-container.props.autogenerated';

export interface IAvailabilityContainerViewProps extends IAvailabilityContainerProps<IAvailabilityContainerData> {
    rows: React.ReactNode[];
    header: string;
    customClass: string;
}

/**
 *
 * AvailabilityContainer component
 * @extends {React.PureComponent<IAvailabilityContainerProps<IAvailabilityContainerData>>}
 */
class AvailabilityContainer extends React.PureComponent<IAvailabilityContainerProps<IAvailabilityContainerData>> {
    public render(): JSX.Element | null {
        const viewProps= {
            ...this.props,
            rows: this.props.slots.availabilityBlocks,
            header: this.props.config.header ? this.props.config.header : '',
            customClass: this.props.config.className ? this.props.config.className : ''
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default AvailabilityContainer;
